/**
 * Copyright (C) Smartlife 2021 The Smartlife Connet Project.
 *
 * Clear Main button used accrossed the app
 *
 * Changes Since initial code
 *  1. Linting - Maduka Dilshan
 *
 * @file This file define the main clear Button
 * @author Dinuka Bandara
 * @since 1.0.0
 */
import React from 'react';
import PropsTypes from 'prop-types';
import Button from '@mui/material/Button';

import styles from './ClearLeftIconButton.module.css';

type ComponentProps = {
  text?: string;
  children?: any;
  onClick?: () => void;
  disable?: boolean;
  color?: string;
};

/**
 * Main Green color button component of the app
 * @callback onClickCB
 * @param {Object} props            component props
 * @param {String} props.text       Text to display inside the button
 * @param {String} props.children   Custom JSX.Element to render as child
 * @param {onClickCB} props.onClick Fires when user click the button
 * @param {Boolean} props.disabled  Flag that determine if the button is clickable or not
 *
 * @returns JSX.Element
 */
const ClearLeftIconButton: React.FunctionComponent<ComponentProps> = ({
  text,
  children,
  onClick,
  disable = false,
  color = 'green',
}) => (
  <Button
    disableElevation
    disabled={disable}
    className={color === 'green' ? styles.btnBgGreen : styles.btnBgRed}
    size="small"
    onClick={() => {
      if (!disable && onClick) {
        onClick();
      }
    }}
  >
    <div className={styles.buttonChildContainer}>
      {children != null ? (
        <div
          className={
              color === 'green' ? styles.iconTextGreen : styles.iconTextRed
            }
        >
          {children}
        </div>
      ) : (
        <div />
      )}
      <div
        className={
            color === 'green' ? styles.btnTextGreen : styles.btnTextRed
          }
      >
        {' '}
        {text}
      </div>
    </div>
  </Button>
);

ClearLeftIconButton.propTypes = {
  text: PropsTypes.string,
  children: PropsTypes.oneOfType([
    PropsTypes.arrayOf(PropsTypes.node),
    PropsTypes.node,
  ]),
  onClick: PropsTypes.func,
  disable: PropsTypes.bool,
  color: PropsTypes.string,
};

ClearLeftIconButton.defaultProps = {
  text: '',
  children: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick: () => {},
  disable: false,
  color: 'white',
};

export default ClearLeftIconButton;
